import * as types from "../mutation-types";

/*
0 - Standard
1 - AutoBenchByAssetAllocation
2 - AutoBenchByCategory
3 - Custom
*/
const BenchmarkTypes = [
    {
        id: 1,
        labelId: "benchmark_auto_by_asset_allocation"
    },
    {
        id: 2,
        labelId: "benchmark_auto_by_mstar_category"
    },
    {
        id: 0,
        labelId: "benchmark_standard"
    },
    {
        id: 3,
        labelId: "benchmark_custom"
    }
];

function initialState() {
    return {
        benchmarkType: 0,
        includeBenchmark: false,
        benchmarkHoldings: [
            {
                securityId: "XIUSA04G92",
                securityName: "S&P 500 TR USD(USD)",
                identifier: "XIUSA04G92"
            }
        ],
        customBenchmarkId: "",
        customBenchmarkName: ""
    };
}

const state = {
    ...initialState()
};

const getters = {
    benchmarkTypes() {
        return BenchmarkTypes;
    },
    benchmarkSetting(state) {
        if (state.includeBenchmark) {
            const benchmarkSetting = {
                benchmarkType: state.benchmarkType,
                includeBenchmark: true
            };
            if (state.benchmarkType === 0) {
                benchmarkSetting.benchmarkHoldings = state.benchmarkHoldings;
            } else if (state.benchmarkType === 3) {
                benchmarkSetting.customBenchmarkId = state.customBenchmarkId;
                benchmarkSetting.customBenchmarkName = state.customBenchmarkName;
            }
            return benchmarkSetting;
        }
        return undefined;
    },
    preferenceBenchmark(state, getters, rootState, rootGetters) {
        return rootState.settings.preferences.benchmark;
    }
};

const mutations = {
    [types.UPDATE_BENCHMARK_SETTING](state, data) {
        if (data) {
            state.includeBenchmark = data.includeBenchmark || false;
            state.benchmarkType = data.benchmarkType;
            if (data.benchmarkHoldings) {
                state.benchmarkHoldings = data.benchmarkHoldings;
            }
            if (data.customBenchmarkId) {
                state.customBenchmarkId = data.customBenchmarkId;
                state.customBenchmarkName = data.customBenchmarkName;
            }
        } else {
            state.includeBenchmark = false;
        }
    },
    [types.SET_BENCHMARK_HOLDINGS](state, data) {
        state.benchmarkHoldings = data;
    },
    [types.SET_INCLUDE_BENCHMARK](state, data) {
        state.includeBenchmark = data;
    },
    [types.SET_BENCHMARK_TYPE](state, data) {
        state.benchmarkType = data;
        if (state.benchmarkType !== 3) {
            state.customBenchmarkId = "";
            state.customBenchmarkName = "";
        }
    },
    [types.SET_CUSTOMBENCHMARK_ID](state, data) {
        state.customBenchmarkId = data;
    },
    [types.SET_CUSTOMBENCHMARK_NAME](state, data) {
        state.customBenchmarkName = data;
    },
    [types.RESET](state) {
        const initialData = initialState();
        Object.keys(initialData).forEach(key => {
            state[key] = initialData[key];
        });
    }
};

export default {
    state,
    getters,
    mutations
};
